import dateFormat from 'dateformat';

export default class ResultSubview {
  
  constructor(parent) {
    this.parent = parent;
    this.el = parent.el.querySelector('.result-subview'); 
    
    this.router = parent.router;
    this.templateSettings = { interpolate: /(?:<%=|{{)([\s\S]+?)(?:%>|}})/g };
    this.template = _.template(parent.el.querySelector('#service-plan-result-template').innerHTML.replaceAll('\\', ''), this.templateSettings);
    this.resultEl = this.el.querySelector('.result');
  }

  show() {
    this.populate();
    this.el.classList.remove('hide');
  }

  hide() {
    this.el.classList.add('hide');
  }

  populate() {
    this.resultEl.innerHTML = this.template({
      result: this.parent.result,
      dateFormat,
    });
  }
}
